/** The rows per page of each followed list on the Watchlist. */
export const WATCHLIST_PAGE_SIZE = 10;
